import styled from 'react-emotion'
import {
  mobile,
  customDevice,
  minDeviceWidth
} from '../../../../../utils/mixins'

import {
  Typo16PinkishGreyDI,
  Typo18whiteFourDefaultDDI,
  Typo14PinkishGreyDDI
} from '../../../../../themes/Fonts/Din2014'

export const TestimonialDescriptionImageItemContainer = styled('div')`
  margin-right: 24px !important;
  :nth-last-child(1) {
    margin-right: 0;
    ${customDevice(320, 601)} {
      margin-right: unset !important;
    }
  }
  ${customDevice(320, 601)} {
    margin-left: unset !important;
    margin-right: unset !important;
  }
  ${minDeviceWidth(768)} {
    width: 18% !important;
  }
`
export const TestimonialDescriptionContainer = styled('div')`
  display: flex;
  flex-direction: column;
`
export const TestimonialDescription = styled(Typo16PinkishGreyDI)`
  line-height: 1.5;
  padding-top: 18px;
  padding-bottom: 10px;
  ${mobile} {
    font-size: 14px;
  }
`
export const TestimonialName = styled(Typo18whiteFourDefaultDDI)`
  line-height: normal;
  text-align: right;
  margin-right: 5px;
  ${mobile} {
    font-size: 15px;
  }
`

export const CountryName = styled(Typo14PinkishGreyDDI)`
  text-align: right;
  line-height: normal;
  letter-spacing: normal;
  margin-right: 5px;
`

export const TestimonialContainer = styled('div')`
  display: flex;
`



// WEBPACK FOOTER //
// ./src/components/ExperimentalMarketing/IbCricketAtIpl2019/TestimonialSlick/TestimonialDescriptionImageItem/styledComponents.js